import { Badge } from "@emdur/ui";
import {
  type Agent,
  type AgentCreate,
  agentOperationLines,
} from "../lib/agents";
import type { CapabilityItem } from "../lib/clients";
import { PermissionList } from "./Permissions";

/** Agent-specific operation copy inside the shared grouped permission/decision lines. */
export function AgentPermissions({
  agent,
  catalogue,
  review = false,
}: {
  agent: AgentCreate | Agent;
  catalogue: CapabilityItem[];
  review?: boolean;
}) {
  return (
    <PermissionList
      permissions={agent.capabilities}
      catalogue={catalogue}
      marker={review ? "+" : undefined}
      subject="agent"
      reasons={Object.fromEntries(
        agent.capabilities.map((capability) => [
          capability,
          agent.disclosure?.intended_purpose ?? "",
        ]),
      )}
      extra={(capability) => (
        <ul className="mt-3 space-y-2 text-sm">
          {agentOperationLines(agent, catalogue, capability).map(
            (operation) => (
              <li key={operation.id}>
                <span>
                  {operation.title}: {operation.words.toLowerCase()}
                </span>
                {operation.read && (
                  <span className="text-muted">. Reads run directly.</span>
                )}
                {operation.narrowingOnly && (
                  <span className="text-muted">
                    . Acts only when reducing access; new access needs approval.
                  </span>
                )}
                {operation.level >= 2 && (
                  <span className="ms-2">
                    <Badge tone="danger">Acts without asking</Badge>
                  </span>
                )}
              </li>
            ),
          )}
        </ul>
      )}
    />
  );
}
